import { useEffect, useState } from 'react';
import { reminderDue, type OnboardingRecord } from '../../lib/onboardingModel';
import { loadRecord, saveRecord } from '../../lib/onboardingStore';

export default function ProReminder() {
  const [record, setRecord] = useState<OnboardingRecord | null>(() => loadRecord());
  const due = reminderDue(record);

  useEffect(() => {
    if (!due || !record || record.notificationChoice !== 'granted') return;
    if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
    try {
      void new Notification('My New Start', {
        body: 'Pro ၇ ရက် က ၂ ရက်အလိုပါ။ အခမဲ့သင်ခန်းစာတွေ ဆက်သုံးလို့ရပါတယ်။ Your Pro pass ends in 2 days. Free lessons stay available.',
      });
    } catch {
      // The site can be open without a notification permission that still sticks.
    }
  }, [due, record]);

  if (!due || !record) return null;

  return (
    <div className="font-myanmar border-b border-amber-200 bg-amber-50 px-4 py-3" data-testid="pro-reminder">
      <div className="mx-auto flex w-full max-w-lg items-start justify-between gap-3">
        <p className="text-sm leading-snug text-amber-950">
          Pro ၇ ရက် က ၂ ရက်အလိုပါ။ အခမဲ့သင်ခန်းစာတွေ ဆက်သုံးလို့ရပါတယ်။
          <span className="mt-1 block text-amber-900">Your Pro pass ends in 2 days. Free lessons stay available.</span>
        </p>
        <button
          type="button"
          className="min-h-[44px] shrink-0 rounded-xl px-3 text-sm font-semibold text-amber-950"
          onClick={() => {
            const next = { ...record, proReminderSeen: true };
            saveRecord(next);
            setRecord(next);
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
}
